export default {
  "gatehouse": "Porte d'entrée",
  "openControlPanel": "Panneau de commande ouvert",
  "totalAccess": "Accès total",
  "deniedAccess": "Refus d ' accès",
  "activeAlerts": "Alertes actives",
  "openIncidents": "Incidents ouverts",
  "highRisk": "Risque élevé",
  "accessLogHistory": "Journal historique",
  "refresh": "Actualiser",
  "export": "Exportation",
  "searchByMemberNameOrZone": "Recherche par nom de membre ou zone...",
  "status": "Statut",
  "allStatus": "Tous les statuts",
  "granted": "Subventions",
  "denied": "Nié",
  "zone": "Zone",
  "allZones": "Toutes les zones",
  "method": "Méthode",
  "allMethods": "Toutes les méthodes",
  "member": "Membre",
  "time": "Heure",
  "riskLevel": "Niveau de risque",
  "notes": "Notes",
  "noAccessLogsFoundMatchingYourCriteria": "Aucun journal d'accès trouvé correspondant à vos critères",
  "cameraEventTimeline": "Heure de l'événement de la caméra",
  "exportView": "Vue d ' exportation",
  "searchByCameraName": "Recherche par le nom de la caméra...",
  "eventType": "Type d ' événement",
  "allEventTypes": "Tous les types d'événement",
  "person": "Personne",
  "vehicle": "Véhicule",
  "motion": "MOUVEMENT",
  "doorbell": "ATTENTION",
  "loadingEvents": "Chargement des événements...",
  "noEventsFoundMatchingCriteria": "Aucun évènements n'a trouvé de critères adéquats.",
  "eventThumbnail": "Image de l'événement",
  "playback": "Lecture",
  "createIncident": "Créer un incident",
  "offline": "HORS LIGNE",
  "loadingCameras": "Chargement des caméras...",
  "cameraWall": "Mur de caméra",
  "grid": "Quadrillage",
  "accessControlScanner": "Scanner de contrôle d'accès",
  "scanQrCodeRfidOrEnterMembershipNumber": "Scannez le code QR, RFID, ou entrez le numéro d'adhésion...",
  "clear": "Effacer",
  "staffOverride": "Recrutement du personnel",
  "gateCameras": "Caméras de porte",
  "recentGateActivity": "Activité de porte récente",
  "expectedArrivals": "Arrivées escomptées",
  "noExpectedArrivalsToday": "Pas d'arrivée attendue aujourd'hui",
  "quickActions": "Actions rapides",
  "reportIncident": "Incidents",
  "viewLiveCameras": "Voir les caméras en direct",
  "emergencyOverride": "Démarrage d ' urgence",
  "incidentManagement": "Gestion des incidents",
  "trackAndManageSecurityIncidentsAndReports": "Suivre et gérer les incidents et les rapports en matière de sécurité",
  "searchIncidents": "Des incidents de recherche...",
  "severity": "Gravité",
  "allSeverity": "Toute Severity",
  "type": "Type",
  "allTypes": "Tous les types",
  "view": "Afficher",
  "update": "Mise à jour",
  "actionsTaken": "Actions prises :",
  "witnesses": "Témoins :",
  "followupRequired": "Suivi nécessaire",
  "noIncidentsFoundMatchingYourCriteria": "Aucun incident n'a été trouvé correspondant à vos critères",
  "incidentReportingFormWouldBeImplementedHere": "Le formulaire de déclaration d'incident serait mis en œuvre ici.",
  "close": "Fermer",
  "securityAlerts": "Alertes de sécurité",
  "searchAlerts": "Alertes de recherche...",
  "allRisk": "Tous les risques",
  "alertType": "Alerte type",
  "acknowledge": "Remerciements",
  "resolve": "Résoudre le problème",
  "recommendedAction": "Mesures recommandées:",
  "resolutionNotes": "Notes de résolution :",
  "noSecurityAlertsFoundMatchingYourCriteria": "Aucune alerte de sécurité n'a été trouvée correspondant à vos critères",
  "recentAccessActivity": "Activité d'accès récente",
  "prioritySecurityAlerts": "Alertes prioritaires en matière de sécurité",
  "noHighpriorityAlerts": "Pas d'alertes à haut prix",
  "accessTrends7Days": "Tendances d'accès (7 jours)",
  "zoneAccessDistribution": "Zone d ' accès",
  "alertRiskLevels": "Niveaux de risque d'alerte",
  "zoneStatusOverview": "Situation de la zone",
  "bookingRequired": "Réservation requise",
  "unifiProtectIntegration": "UniFi Protéger l'intégration",
  "connected": "Connecté",
  "disconnected": "Déconnecté",
  "totalCameras": "Nombre total de caméras",
  "online": "En ligne",
  "recording": "Enregistrement:",
  "motionAlerts": "Alertes de mouvement",
  "cameraLocations": "Bureaux de la caméra",
  "fullscreen": "Plein écran",
  "cameraOffline": "Caméra Offline",
  "rec": "REC",
  "play": "Jeu",
  "stop": "Arrête.",
  "model": "Modèle :",
  "ipAddress": "Adresse IP:",
  "nightVision": "Vision nocturne :",
  "selectACameraToViewLiveFeed": "Sélectionnez une caméra pour afficher l'alimentation en direct",
  "unifiIntegrationSettings": "Réglages d'intégration UniFi",
  "unifiConsoleIp": "Console uniFi IP",
  "username": "Nom",
  "apiKey": "API clé",
  "testConnection": "Montage d ' essai",
  "saveSettings": "Sauvegarder les paramètres",
  "zoneManagement": "Gestion des zones",
  "configureAccessPermissionsAndSettingsForDifferentClubZones": "Configurer les permissions d'accès et les réglages pour différentes zones de club",
  "addZone": "Ajouter la zone",
  "capacity": "Capacité",
  "hours": "Heures",
  "allowedMemberships": "Membres autorisés",
  "allMembers": "Tous les Membres",
  "emergencyOverrideActive": "Secours d ' urgence",
  "active": "Actif",
  "edit": "Modifier",
  "zoneConfigurationFormWouldBeImplementedHere": "Le formulaire de configuration de zone serait mis en œuvre ici.",
  "inactive": "Inactif",
  "enabled": "Activé",
  "disabled": "Désactivé",
  "editZone": "Modifier Zone",
  "addNewZone": "Ajouter une nouvelle zone",
  "editIncident": "Modification",
  "reportNewIncident": "Rapport New Incident",
  "scanning": "Scanner...",
  "scan": "Analyse",
  "selectCamera": "Sélectionnez Caméra",
  "live": "EN DIRECT",
  "unlimited": "Non limitée",
  "low": "Faible",
  "medium": "Moyen",
  "high": "Élevé",
  "critical": "Critique",
  "device": "Appareil: {id}",
  "anomaliesOne": "Anomalies : {count}",
  "anomaliesOther": "Anomalies : {count}",
  "accessSummary": "Affichage de {shown} de {total} journaux d'accès",
  "alertsSummary": "Affichage de {shown} de {total} alertes",
  "incidentsSummary": "Affichage de {shown} de {total} incidents",
  "grantedCount": "Subvention : {count}",
  "deniedCount": "Rejetée : {count}",
  "activeCount": "Actif: {count}",
  "acknowledgedCount": "Remerciements : {count}",
  "resolvedCount": "Résolu: {count}",
  "openCount": "Ouvert: {count}",
  "investigatingCount": "Enquête : {count}",
  "confidence": "{count} % de confiance",
  "acknowledgedBy": "Reconnu par {name}",
  "reportedBy": "Rapporté par : {name}",
  "involves": "Implique: {name}",
  "photosOne": "Photos jointes : {count}",
  "photosOther": "Photos jointes : {count}",
  "riskLabel": "{level} risque",
  "severityLabel": "{level} gravité",
  "memberIdentity": "{type} Membre # {number}",
  "visiting": "Visite: {name}",
  "host": "Hébergement : {name}",
  "expected": "Attendu : {time}",
  "accessGranted": "Accès accordé",
  "accessDenied": "Accès refusé",
  "capacitySummary": "Capacité: {current} / {max}",
  "accessHours": "Accès: {start} - {end}",
  "liveFeed": "Alimentation en direct: {name}",
  "lastMotion": "Dernière motion : {time}",
  "validMembership": "Membres valides",
  "inactiveMembership": "Composition inactive",
  "validVisitorPass": "Passe de visiteur valide",
  "invalidVisitorPass": "Pas de visiteur invalide",
  "invalidScanCode": "Code d'analyse invalide",
  "systemError": "Erreur système",
  "overrideApproved": "Postes pourvus",
  "loadError": "Impossible de charger les données de sécurité. Veuillez réessayer.",
  "dateUnavailable": "Date indisponible",
  "noCameras": "Pas de caméras disponibles",
  "fullscreenCamera": "Voir la caméra plein écran",
  "pauseCamera": "Pause vue en direct",
  "playCamera": "Jouer en direct vue",
  "muteCamera": "Appareil-photomètre",
  "unmuteCamera": "Caméra immuable",
  "eventDate": "Date de l ' événement",
  "settings": "Paramètres",
  "accessCount": "Compte d ' accès",
  "enums": {
    "status": {
      "granted": "accordée",
      "denied": "nié",
      "active": "actif",
      "inactive": "inactif",
      "acknowledged": "reconnu",
      "resolved": "résolus",
      "dismissed": "l ' affaire a été rejetée.",
      "open": "ouvert",
      "investigating": "Enquêtes",
      "closed": "fermé",
      "online": "en ligne",
      "offline": "hors ligne",
      "maintenance": "entretien"
    },
    "risk": {
      "low": "faible",
      "medium": "moyen",
      "high": "haut",
      "critical": "critiques critiques"
    },
    "severity": {
      "low": "faible",
      "medium": "moyen",
      "high": "haut",
      "critical": "critiques critiques"
    },
    "method": {
      "qr_code": "code qr",
      "manual_override": "override manuelle",
      "rfid": "rfid"
    },
    "event": {
      "person": "personne",
      "vehicle": "Véhicule",
      "motion": "motion",
      "doorbell": "ATTENTION"
    }
  },
  "cameraIncidentDescription": "Incident basé sur {type} détection à {camera} ."
};
